/**
 * Toast notification hook
 *
 * Simple wrapper around sonner for toast notifications.
 * For now, we'll use sonner directly. This hook exists for compatibility
 * with copied shadcn/ui components.
 */

import { toast as sonnerToast } from "sonner";

export type ToastProps = {
  id?: string;
  title?: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  variant?: "default" | "destructive";
};

export function useToast() {
  const toast = (props: ToastProps) => {
    if (props.variant === "destructive") {
      sonnerToast.error(props.title, {
        description: props.description,
      });
    } else {
      sonnerToast(props.title, {
        description: props.description,
      });
    }
  };

  return {
    toast,
    toasts: [], // Not implemented, but exists for compatibility
    dismiss: () => {},
  };
}
